let primaryNavToggle = $('.primary-nav-dropdown-toggle');

primaryNavToggle.on('click', function(e) {
    e.preventDefault();

    let dropdownContainer = $(this).parent().find('.dropdown-container');

    if($(this).parent().hasClass('active')) {
        $(this).parent().removeClass('active');
        dropdownContainer.fadeOut();
        // dropdownContainer.removeClass('active');
        // if($(window).width() < 992) {
        //     dropdownContainer.slideUp();
        // } else {
        //     dropdownContainer.fadeOut();
        // }
    } else {
        $('.dropdown-container').not(dropdownContainer).parent().removeClass('active');
        $('.dropdown-container').not(dropdownContainer).fadeOut();

        $(this).parent().addClass('active');
        dropdownContainer.fadeIn();
    }
});

let mobileNavToggle = $('#site-navigation-open'),
    mobileMenu = $('#primary-navigation'),
mobileSubNavClose = $('.mobile-back-button');

mobileNavToggle.on('click', function(e) {
    e.preventDefault();
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        mobileMenu.fadeOut();
    } else {
        $(this).addClass('active');
        mobileMenu.fadeIn();
    }
});

mobileSubNavClose.on('click', function(e) {
    e.preventDefault();
    $('.dropdown-container').fadeOut();
    $('.primary-nav-dropdown-toggle').parent().removeClass('active');
    // $(this).closest('.dropdown-container').fadeOut();
    // mobileNavToggle.removeClass('active');
});
